module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"no-order-description":"Você ainda não recebeu nenhum pedido.","no-order-title":"Não há pedidos","column-archive":"Zip","column-created-at":"Feito em","column-email":"E-mail","column-paid-at":"Entregue","column-name":"Nome","column-total-cents":"Valor"}}')
  delete Component.options._Ctor
}
